export default "__VITE_ASSET__CFOaSevv__"